function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#ccc;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, React.createElement("g", {
  id: "Camada_1-2",
  "data-name": "Camada 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M83.71.13V0H0V51.44H7.08l9.17-10a6.77,6.77,0,0,1,9.35-.56l0,0a6.35,6.35,0,0,1,.5,9.15l-1.22,1.33H41.08a41.77,41.77,0,0,0,7.7-24.17A41.93,41.93,0,0,0,38.79.13h1.92a41.88,41.88,0,0,1,10,27.14A41.77,41.77,0,0,1,43,51.44H85.64V.13Zm-68,11.45a6.78,6.78,0,0,1-9.37,0h0l0,0a6.37,6.37,0,0,1,0-9.17L8.66.13H27.5Z"
})));

var SvgIntro = function SvgIntro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 85.64 51.44",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIntro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/INTRO.92ae6cf5.svg";
export { ForwardRef as ReactComponent };